import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.guide03.workflow-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem1Description: {
    id: `${PREFIX}.accordion-item1.description`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordion-item2.title`,
  },
  accordionItem2Description: {
    id: `${PREFIX}.accordion-item2.description`,
  },
  accordionItem3Title: {
    id: `${PREFIX}.accordion-item3.title`,
  },
  accordionItem3Description: {
    id: `${PREFIX}.accordion-item3.description`,
  },
  accordionItem4Title: {
    id: `${PREFIX}.accordion-item4.title`,
  },
  accordionItem4Description: {
    id: `${PREFIX}.accordion-item4.description`,
  },
  accordionItem5Title: {
    id: `${PREFIX}.accordion-item5.title`,
  },
  accordionItem5Description: {
    id: `${PREFIX}.accordion-item5.description`,
  },
  accordionItem6Title: {
    id: `${PREFIX}.accordion-item6.title`,
  },
  accordionItem6Description: {
    id: `${PREFIX}.accordion-item6.description`,
  },
  accordionItem7Title: {
    id: `${PREFIX}.accordion-item7.title`,
  },
  accordionItem7Description: {
    id: `${PREFIX}.accordion-item7.description`,
  },
  signalAndDataFlowsTitle: {
    id: `${PREFIX}.signalAndDataFlows.title`,
  },
  signalAndDataFlowsDescription: {
    id: `${PREFIX}.signalAndDataFlows.description`,
  },
  finalMixingTitle: {
    id: `${PREFIX}.finalMixing.title`,
  },
  finalMixingDescription: {
    id: `${PREFIX}.finalMixing.description`,
  },
  printmasteringAndPackagingTitle1: {
    id: `${PREFIX}.printmasteringAndPackaging.title1`,
  },
  printmasteringAndPackagingDescription1: {
    id: `${PREFIX}.printmasteringAndPackaging.description1`,
  },
  printmasteringAndPackagingTitle2: {
    id: `${PREFIX}.printmasteringAndPackaging.title2`,
  },
  printmasteringAndPackagingDescription2: {
    id: `${PREFIX}.printmasteringAndPackaging.description2`,
  },
  qualityControlTitle1: {
    id: `${PREFIX}.qualityControl.title1`,
  },
  qualityControlDescription1: {
    id: `${PREFIX}.qualityControl.description1`,
  },
  qualityControlTitle2: {
    id: `${PREFIX}.qualityControl.title2`,
  },
  qualityControlDescription2: {
    id: `${PREFIX}.qualityControl.description2`,
  },
  qualityControlDescription3: {
    id: `${PREFIX}.qualityControl.description3`,
  },
  qualityControlButton: {
    id: `${PREFIX}.qualityControl.button`,
  },
  binauralMonitoringTitle: {
    id: `${PREFIX}.binauralMonitoring.title`,
  },
  binauralMonitoringDescription: {
    id: `${PREFIX}.binauralMonitoring.description`,
  },
  binauralMonitoringDescription2: {
    id: `${PREFIX}.binauralMonitoring.description2`,
  },
  panningAndObjectPlacementTitle: {
    id: `${PREFIX}.panningAndObjectPlacement.title`,
  },
  panningAndObjectPlacementDescription: {
    id: `${PREFIX}.panningAndObjectPlacement.description`,
  },
  panningAndObjectPlacementButton: {
    id: `${PREFIX}.panningAndObjectPlacement.button`,
  },
  panningAndObjectPlacementDescription2: {
    id: `${PREFIX}.panningAndObjectPlacement.description2`,
  },
  panningAndObjectPlacementDescription3: {
    id: `${PREFIX}.panningAndObjectPlacement.description3`,
  },
  panningAndObjectPlacementDescription4: {
    id: `${PREFIX}.panningAndObjectPlacement.description4`,
  },
  editingTitle: {
    id: `${PREFIX}.editing.title`,
  },
  editingDescription: {
    id: `${PREFIX}.editing.description`,
  },
  editingDescription2: {
    id: `${PREFIX}.editing.description2`,
  },
  editingTitle2: {
    id: `${PREFIX}.editing.title2`,
  },
  editingTitle3: {
    id: `${PREFIX}.editing.title3`,
  },
  organisingTheSessionTitle: {
    id: `${PREFIX}.organisingTheSession.title`,
  },
  organisingTheSessionTitle1: {
    id: `${PREFIX}.organisingTheSession.title1`,
  },
  organisingTheSessionDescription1: {
    id: `${PREFIX}.organisingTheSession.description1`,
  },
  organisingTheSessionTitle2: {
    id: `${PREFIX}.organisingTheSession.title2`,
  },
  organisingTheSessionDescription2: {
    id: `${PREFIX}.organisingTheSession.description2`,
  },
  organisingTheSessionTitle3: {
    id: `${PREFIX}.organisingTheSession.title3`,
  },
  organisingTheSessionDescription3: {
    id: `${PREFIX}.organisingTheSession.description3`,
  },
  organisingTheSessionTitle4: {
    id: `${PREFIX}.organisingTheSession.title4`,
  },
  organisingTheSessionDescription4: {
    id: `${PREFIX}.organisingTheSession.description4`,
  },
  organisingTheSessionTitle5: {
    id: `${PREFIX}.organisingTheSession.title5`,
  },
  organisingTheSessionDescription5: {
    id: `${PREFIX}.organisingTheSession.description5`,
  },
  organisingTheSessionButton1: {
    id: `${PREFIX}.organisingTheSession.button1`,
  },
  organisingTheSessionButton2: {
    id: `${PREFIX}.organisingTheSession.button2`,
  },
  organisingTheSessionButton3: {
    id: `${PREFIX}.organisingTheSession.button3`,
  },
  organisingTheSessionButton4: {
    id: `${PREFIX}.organisingTheSession.button4`,
  },
  organisingTheSessionButton5: {
    id: `${PREFIX}.organisingTheSession.button5`,
  },
  organisingTheSessionNewSessionTitle: {
    id: `${PREFIX}.organisingTheSession.newSession.title`,
  },
  organisingTheSessionNewSessionDescription: {
    id: `${PREFIX}.organisingTheSession.newSession.description`,
  },
  organisingTheSessionTrackGroupsTitle: {
    id: `${PREFIX}.organisingTheSession.trackGroups.title`,
  },
  organisingTheSessionTrackGroupsDescription: {
    id: `${PREFIX}.organisingTheSession.trackGroups.description`,
  },
  organisingTheSessionOrganiseTracksTitle: {
    id: `${PREFIX}.organisingTheSession.organiseTracks.title`,
  },
  organisingTheSessionOrganiseTracksDescription: {
    id: `${PREFIX}.organisingTheSession.organiseTracks.description`,
  },
  organisingTheSessionSubmixesTitle: {
    id: `${PREFIX}.organisingTheSession.submixes.title`,
  },
  organisingTheSessionSubmixesDescription: {
    id: `${PREFIX}.organisingTheSession.submixes.description`,
  },
  organisingTheSessionDolbyBridgeTitle: {
    id: `${PREFIX}.organisingTheSession.dolbyBridge.title`,
  },
  organisingTheSessionDolbyBridgeDescription: {
    id: `${PREFIX}.organisingTheSession.dolbyBridge.description`,
  },
  organisingTheSessionBedChannelsTitle: {
    id: `${PREFIX}.organisingTheSession.bedChannels.title`,
  },
  organisingTheSessionBedChannelsDescription: {
    id: `${PREFIX}.organisingTheSession.bedChannels.description`,
  },
  organisingTheSessionBedChannelsDescription2: {
    id: `${PREFIX}.organisingTheSession.bedChannels.description2`,
  },
  organisingTheSessionBedChannelsDescription3: {
    id: `${PREFIX}.organisingTheSession.bedChannels.description3`,
  },
  organisingTheSessionObjectsPanningTitle: {
    id: `${PREFIX}.organisingTheSession.objectsPanning.title`,
  },
  organisingTheSessionObjectsPanningDescription: {
    id: `${PREFIX}.organisingTheSession.objectsPanning.description`,
  },
});
